import PropTypes from 'prop-types';
import React from 'react';
import {
  getCurrentStepId,
  useWizardService,
} from '@bingads-webui-react/wizard';
import { layoutConfig } from './config';

export const CustomLayoutTemplate = ({ items }) => {
  const { state } = useWizardService();
  const currentStepId = getCurrentStepId(state);
  const config = layoutConfig[currentStepId];
  const {
    noBlocker,
    customBlocker,
    template: Template,
  } = config;
  const newItems = { ...items };

  if (noBlocker) {
    newItems.Blocker = undefined;
  } else if (customBlocker) {
    newItems.Blocker = customBlocker;
  }

  return <Template items={newItems} />;
};

CustomLayoutTemplate.propTypes = {
  items: PropTypes.shape({}).isRequired,
};
